import { render, staticRenderFns } from "./70.vue?vue&type=template&id=1ac28fcf&scoped=true&"
import script from "./70.vue?vue&type=script&lang=js&"
export * from "./70.vue?vue&type=script&lang=js&"
import style0 from "./70.vue?vue&type=style&index=0&id=1ac28fcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac28fcf",
  null
  
)

export default component.exports